import React from "react";
import { Link } from "react-router-dom";
import Services from "../../api/Services";
import SectionTitle from "../SectionTitle/SectionTitle";
import ServiceCard from "./ServiceCard";
import ShapeOn from "../../images/services/bg.webp";

const ServiceSection = (props) => {
  return (
    <section className={"section-padding " + props.hclass}>
      <div className="top-img">
        <img src={ShapeOn} alt="" />
      </div>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12">
            <SectionTitle
              title="Summit Objectives"
              subtitle=""
              titleStyle={{ color: "White" }}
              paragarap={
                <>
                  In today's fast-paced business landscape, maintaining healthy cash flow is essential for survival and growth. Cash Flow Summit 2026 is a premier event designed to equip entrepreneurs, finance professionals, and business leaders with proven{" "}
                  <Link
                    to="/blog/cash-flow-strategies"
                    onClick={() => window.scrollTo(10, 0)}
                    style={{ textDecoration: "underline", fontWeight: 600 }}
                  >
                    cash flow strategies
                  </Link>{" "}
                  to fuel sustainable success. Whether you're struggling with financial bottlenecks, looking to scale your business, or want to optimize your financial processes - this summit is your ultimate guide to mastering cash flow.
                </>
              }
            />
            
          </div>
        </div>
        <div className="services-wrap">
          <div className="row" style={{ display: "flex", flexWrap: "wrap" }}>
            {Services.map((item, sindx) => (
              <div
                className="col col-xl-3 col-lg-6 col-md-6 col-12"
                key={sindx}
                style={{ display: "flex" }}
              >
                <ServiceCard
                  key={sindx}
                  title={item.title}
                  img={item.sImg}
                  slug={item.slug}
                  sdescription={item.description}
                  number={item.Id}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceSection;
